module.exports = __webpack_public_path__ + "img/chunenggui_us.d21d2635.png";